var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6818 1.5H9.31818C5.00032 1.5 1.5 5.00032 1.5 9.31818V53.6818C1.5 57.9997 5.00032 61.5 9.31818 61.5H53.6818C57.9997 61.5 61.5 57.9997 61.5 53.6818V9.31818C61.5 5.00032 57.9997 1.5 53.6818 1.5Z",
    fill: "white",
    stroke: "#01B187",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15C16.5523 15 17 15.4477 17 16V45C17 47.2091 18.7909 49 21 49H42C42.5523 49 43 49.4477 43 50C43 50.5523 42.5523 51 42 51H21C17.6863 51 15 48.3137 15 45V16C15 15.4477 15.4477 15 16 15Z",
    fill: "#01B187"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 43V21L37 11H23C20.7909 11 19 12.7909 19 15V43C19 45.2091 20.7909 47 23 47H43C45.2091 47 47 45.2091 47 43ZM43.1716 20L38 14.8284V20H43.1716ZM39.7071 29.7071C40.0976 29.3166 40.0976 28.6834 39.7071 28.2929C39.3166 27.9024 38.6834 27.9024 38.2929 28.2929L31 35.5858L27.7071 32.2929C27.3166 31.9024 26.6834 31.9024 26.2929 32.2929C25.9024 32.6834 25.9024 33.3166 26.2929 33.7071L31 38.4142L39.7071 29.7071Z",
    fill: "#01B187"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/SC.1b38cd8e4c3d27a673d691b28eaa22fc.svg";
export { ForwardRef as ReactComponent };